import App from './app'
import { connect } from 'react-redux'

import { getUser } from '../../common/actions/user/'
import { initUserSearchResultsViewType, getUserVideoPlayerStatus } from '../../common/actions/user/preference'
import { toggleOffCanvas, closeModal } from '../../common/actions/layout'

const mapStateToProps = (state) => {
  const { layout, common, searchPage, user, marketing } = state
  const { pageIsOffCanvas, pageCanvasDirection, isModalOpen, openModalType, openModalData } = layout
  const { seoMeta, ingestedContent } = searchPage
  const { banners } = marketing

  return {
    user: user,
    pageIsOffCanvas,
    pageCanvasDirection,
    isModalOpen,
    openModalType,
    openModalData,
    stats: common.stats,
    currentSite: common.currentSite,
    baseUrl: common.baseUrl,
    menuConfig: common.menuConfig,
    errorPage: common.errorPage,
    noIndex: common.noIndex,
    seoMeta,
    ingestedContent,
    banners
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    initUser: () => {
      dispatch(initUserSearchResultsViewType(ownProps.location))
      dispatch(getUserVideoPlayerStatus())
      dispatch(getUser())
    },
    toggleOffCanvas: (direction) => {
      dispatch(toggleOffCanvas(direction))
    },
    closeModal: () => dispatch(closeModal())
  }
}

const AppContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(App)

export default AppContainer



// WEBPACK FOOTER //
// ./client/pages/appContainer.js